import axios from 'axios';

const API_URL = 'https://huongtramcomoc.vn/api/auth/';

const adminLogin = (username, password) => {
  return axios.post(API_URL + 'admin_login.php', {
    username: username,
    password: password
  });
};

const getAdminToken = () => {
  return sessionStorage.getItem('adminToken');
};

// Hàm đăng xuất
const logout = () => {
  sessionStorage.removeItem('adminToken');
};

const authService = {
  adminLogin,
  getAdminToken,
  logout
};

export default authService;